import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';



const customContentStyle = {
    width: '350px',
    maxWidth: 'none',
  };

/**
 * Alerts are urgent interruptions, requiring acknowledgement, that inform the user about a situation.
 */
export default class AlertDialog extends React.Component {
  state = {
    open: false,
  };


  handleClose = () => {
    this.props.handleAlertClose();
  };

  render() {
    const actions = [
      <FlatButton
        label="OK"
        primary={true}
        onClick={this.handleClose}
      />,

    ];

    return (
      <div>
        
        <Dialog
          actions={actions}
         
          modal={false}
          open={this.props.open}
          onRequestClose={this.handleClose}
          contentStyle={customContentStyle}
        >
          {this.props.message}
        </Dialog>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/AlertDialog.js